export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-16 pb-10 overflow-hidden"
    >
      <div className="absolute inset-0 precision-grid-dense opacity-15 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="h-1.5 w-1.5 rounded-full bg-[#CCFF00] shadow-[0_0_10px_#CCFF00]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                System Operational
              </span>
            </div>
            <p className="font-display text-white text-xl md:text-2xl uppercase tracking-tighter max-w-[28ch] leading-tight">
              Revenue infrastructure for teams that refuse to scale chaos.
            </p>
            <p className="mt-6 font-body text-[13px] text-zinc-500 max-w-[40ch]">
              SVGL is a RevOps &amp; GTM engineering firm. We install systems —
              and then we hand them to you.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <FooterCol
              title="System"
              links={[
                { l: "Architecture", href: "#architecture" },
                { l: "Systems", href: "#systems" },
                { l: "Paradigm", href: "#paradigm" },
                { l: "FAQ", href: "#faq" },
              ]}
            />
          </div>
          <div className="col-span-6 md:col-span-2">
            <FooterCol
              title="Company"
              links={[
                { l: "Book a Session", href: "#cta" },
                { l: "Contact", href: "mailto:ops@svgl.systems" },
              ]}
            />
          </div>
        </div>

        <div className="mt-14 ticker-line h-[2px]" />

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div
            style={{ fontSize: "clamp(68px, 16vw, 240px)", lineHeight: 0.85 }}
            data-testid="footer-wordmark"
          >
            <span style={{
              fontFamily: '"Azeret Mono", "IBM Plex Mono", monospace',
              fontWeight: 900,
              letterSpacing: "-0.06em",
              transform: "scaleY(1.15)",
              transformOrigin: "bottom",
              display: "inline-block",
              color: "#ffffff",
              textTransform: "uppercase",
            }}>SVGL</span><span style={{
              display: "inline-block",
              width: "0.27em",
              height: "0.45em",
              background: "#CCFF00",
              marginLeft: "0.14em",
              verticalAlign: "baseline",
              flexShrink: 0,
            }} />
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 pt-6 border-t border-white/10">
          <span>© {new Date().getFullYear()} SVGL Rev/OS · Built for operators</span>
          <span className="flex items-center gap-4">
            <span>v4.2.0</span>
            <span className="flex items-center gap-2">
              <span className="h-1 w-1 rounded-full bg-[#CCFF00] shadow-[0_0_8px_#CCFF00]" />
              All systems nominal
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-5">
        {title}
      </div>
      <ul className="space-y-3">
        {links.map((l) => (
          <li key={l.l}>
            <a
              href={l.href}
              className="font-body text-[13px] text-zinc-300 hover:text-[#CCFF00] transition-colors"
            >
              {l.l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
